export const getConcertDateFromApiStr = (dateStr) => {
  let firstDateStr = dateStr.split('-')[0];
  firstDateStr = firstDateStr.replace(/\s/g, '');
  const parts = firstDateStr.split('.');
  return new Date(parts[2], parts[1] - 1, parts[0]);
}

